import { css } from '@emotion/core'
import { colors, measures, spacing } from 'styles/variables'

const { unit } = measures

export const cardLink = css`
  text-decoration: none;
  color: inherit;
  display: block;
  margin-bottom: ${spacing(2)};
  
  &:hover {
    text-decoration: none;
    color: inherit;
  }
`

export const card = css`
  background-color: #1a1a1a;
  border-radius: ${spacing(2.5)};
  border: 1px solid ${colors.grays.gray7};
  padding: ${spacing(3)};
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #2a2a2a;
  }
`

export const cardContent = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const leftSection = css`
  display: flex;
  align-items: center;
  flex: 1;
`

export const logoContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${spacing(7.5)};
  height: ${spacing(7.5)};
  margin-right: ${spacing(2.5)};
  flex-shrink: 0;
`

export const tournamentLogo = css`
  width: ${spacing(7.5)};
  height: ${spacing(7.5)};
  border-radius: ${spacing(1)};
  object-fit: cover;
`

export const sportIcon = css`
  width: ${spacing(5)};
  height: ${spacing(5)};
  color: ${colors.white100};
  fill: ${colors.white100};
`

export const tournamentInfo = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0; /* Allows text truncation */
`

export const tournamentName = css`
  color: ${colors.white100};
  margin-bottom: ${spacing(0.75)};
  line-height: 1.3;
  font-weight: 700;
  
  /* Ensure text doesn't wrap unnecessarily */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const dateRange = css`
  color: ${colors.white60};
  line-height: 1.2;
  font-weight: 500;
`

export const rightSection = css`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

export const arrowIcon = css`
  width: ${spacing(2)};
  height: ${spacing(2)};
  color: ${colors.white60};
  fill: ${colors.white60};
` 